import {
  getGpitList,
  getGpitTemplate,
  importGpits,
} from "@ckweb/ckfetch/connectables/taskListManagement";

const FETCH_ID = "GlobalTasks";

export const useGetGlobalTasksTemplate = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}Template`, getGpitTemplate, {
    fetchType: "download",
    showGlobalLoadingIndicator: true,
  });

export const useGetGlobalTasks = () =>
  useSafeLocalFetch(`fetch${FETCH_ID}`, getGpitList, {
    fallback: {
      globalBeforeTasks: [],
      globalAfterTasks: [],
    },
  });

export const useSubmitGlobalTasks = () =>
  useSafeLocalFetch(`import${FETCH_ID}`, importGpits, {
    fetchType: "mutate",
    showGlobalLoadingIndicator: true,
    enableGlobalNotifications: true,
  });
